const namespaced = true;

const state = {
    dateInitial: new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        .toISOString()
        .split("T")[0],
    dateFinal: new Date(Date.now()).toISOString().substr(0, 10),
    date_today: new Date(Date.now()).toISOString().substr(0, 10),
    date_next_week: new Date(Date.now()).getDay(),
};
const mutations = {
    MUTATION_SET_DATEINITIAL(state, data) {
        state.dateInitial = data;
    },
    MUTATION_SET_DATEFINAL(state, data) {
        state.dateFinal = data;
    },
    MUTATION_SET_RESET_DATES(state) {
        (state.dateInitial = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
        )
            .toISOString()
            .split("T")[0]),
            (state.dateFinal = new Date(Date.now())
                .toISOString()
                .substr(0, 10)),
            (state.date_today = new Date(Date.now())
                .toISOString()
                .substr(0, 10));
    },
};
const actions = {
    setInitial(context, data) {
        context.commit("MUTATION_SET_DATEINITIAL", data);
    },
    setFinal(context, data) {
        context.commit("MUTATION_SET_DATEFINAL", data);
    },

    resetDates(context) {
        context.commit("MUTATION_SET_RESET_DATES");
    },
};

const getters = {
    nextDate(state) {
        let days = 7 - state.date_next_week;
        let hoy = new Date();
        hoy.setDate(hoy.getDate() + days);
        hoy.setHours(0, 0, 0, 0); // Poner la hora en medianoche
        state.date_next_week = hoy;
        return hoy;
    },
};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
};
